import axios from "axios";

export const getDocumentById = axios.create({
  baseURL: `${process.env.REACT_APP_BASE_URL}/search/get_document_by_id/`,
});
